import { pList, rValue } from '../../../../api/models/.catalog';
import { ActionSubTypes } from '../../../ActionSubTypes';
import Api from '../../../../api/ApiWrapper';
import { IApiAction, IPromiseAction } from '../../../../models/ActionModels';
import ActionFunctions from '../../../core/ActionFunctions';
import { IError } from '../../../../models/StateModels';
import { rOyakKiraBilgileriUstBilgi } from '../../../../api/models/rOyakKiraBilgileriUstBilgi';

export const action_async_start = (body: pList): IPromiseAction<pList> =>
  ActionFunctions.action_async_start_promise(
    ActionSubTypes.API_OYAKKIRABILGILERIUSTBILGI,
    new Api.Bilgi.OyakKiraBilgileriUstBilgi().Request(body),
    false,
    false,
    body
  );

export const action_async_complete = (
  data: rValue<rOyakKiraBilgileriUstBilgi> | null | undefined,
  error: IError | null | undefined
): IApiAction<rOyakKiraBilgileriUstBilgi> =>
  ActionFunctions.action_async_complete_api<rOyakKiraBilgileriUstBilgi>(
    ActionSubTypes.API_OYAKKIRABILGILERIUSTBILGI,
    data?.Value,
    error
  );
